import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltRecorderPlayerExpandedControlsSubtitleButtonIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-expanded-controls-subtitle-button-icon-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecorderPlayerExpandedControlsSubtitleButtonIconWireframe;
